import { Collateral, AutoFactory, OnlinePortalCollateralApi, OnlinePortalCustomersApi } from '@sageworks/jpi';
import { CollateralWithCustomerName } from '@sageworks/dynamic-forms/src/components/form-components/collateral-info/collateral-with-customer-name';

async function getCollateralOnApplicationForEntities(loanApplicationId: number, relatedEntities: number[]): Promise<Collateral[]> {
	const service = AutoFactory.get(OnlinePortalCollateralApi);
	const collateral = (await service.getByLoanApplicationId(loanApplicationId)) as Collateral[];
	let collateralList: Collateral[] = [];
	collateral.forEach(collateral => {
		if (relatedEntities.includes(collateral.customerId)) collateralList.push(collateral);
	});
	return collateralList;
}

export async function getCollateralForEntities(relatedEntities: number[], loanApplicationId: number, isLender: boolean): Promise<Collateral[]> {
	if (relatedEntities.length < 1) return [];
	let collateralList: Collateral[] = [];
	if (isLender) {
		const service = AutoFactory.get(OnlinePortalCollateralApi);
		collateralList = (await service.getByRelatedEntities(relatedEntities)) as Collateral[];
	} else {
		collateralList = await getCollateralOnApplicationForEntities(loanApplicationId, relatedEntities);
	}
	return collateralList.filter(collateral => {
		return !collateral.isDeleted;
	});
}

export async function getCollateralForEntitiesWithCustomerName(
	relatedEntities: number[],
	loanApplicationId: number,
	isLender: boolean
): Promise<CollateralWithCustomerName[]> {
	const collateralObjectList: CollateralWithCustomerName[] = await getCollateralForEntities(relatedEntities, loanApplicationId, isLender);

	const ids = collateralObjectList
		.map<number>(collateral => {
			return collateral.customerId;
		})
		.filter((value, index, self) => {
			return self.indexOf(value) === index;
		});
	const customersService = AutoFactory.get(OnlinePortalCustomersApi);
	if (ids.length < 1) return collateralObjectList;
	const customers = (await customersService.getPaged(1, 1000, undefined, ids)).items ?? [];
	collateralObjectList.forEach(collateral => {
		const customer = customers.find(customer => {
			return customer.id === collateral.customerId;
		});
		if (!customer) {
			collateral.customerName = '';
			return;
		}
		collateral.customerName = customer.name;
	});
	return collateralObjectList;
}